import "masonry-layout";
import { Swal, Cookies, ClipboardJS } from "./vendor";
import { ajaxPost, parceAjaxErrorResponse } from "./js/utils";
import { bsToast, initPlugins } from "./js/plugins";

export const KMSwal = Swal.mixin({
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  buttonsStyling: false,
  heightAuto: false,
  scrollbarPadding: false,
});

export const SwalPost = (url, data, options = {}) => {
  return new Promise((resolve, reject) => {
    KMSwal.fire({
      text: "Əməliyyatı icra etmək istədiyinizə əminsiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Bəli, icra edilsin",
      cancelButtonText: "Xeyr, imtina",
      heightAuto: false,
      ...options,
    }).then((result) => {
      if (result.isConfirmed) {
        ajaxPost(url, data)
          .then((response) => {
            resolve(response);
          })
          .catch((errors) => {
            const errorList = parceAjaxErrorResponse(errors);
            ErrorSwal.fire({ html: errorList.join("<br>") }).then(() => {
              reject(errors);
            });
          });
      } else {
        reject('Swal: "Xeyr, imtina" düyməsinə basıldı');
      }
    });
  });
};

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  buttonsStyling: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("click", Swal.close);
  },
});

export const SuccessSwal = KMSwal.mixin({
  icon: "success",
  text: "Əməliyyat uğurla tamamlandı",
});

export const ErrorSwal = KMSwal.mixin({
  icon: "error",
  titleText: "Xəta baş verdi!",
  text: "Serverə sorğu zamanı xəta baş verdi",
});

export const AlertSwal = KMSwal.mixin({
  showCancelButton: true,
  cancelButtonText: "Xeyr, imtina",
  confirmButtonText: "Bəli, icra edilsin",
});

export const SuccessToast = KMSwal.mixin({
  // title: 'Əla!',
  text: "Əməliyyat uğurla icra edildi",
  icon: "success",
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("mouseclick", Swal.close);
  },
});

window.DjangoMessageErrorCodes = {
  10: "warning",
  20: "info",
  25: "success",
  30: "warning",
  40: "error",
};

// pages
import "./js/common";
import "./js/pages/login";
import "./js/pages/profile";
import "./js/pages/users";
import "./js/pages/domains";
import "./js/pages/banned-ips";
import "./js/pages/sessions";
import "./js/pages/ip-networks";
import "./js/pages/videos";
import "./js/pages/teachers";
import "./js/pages/monitoring";
import "./js/pages/core-settings";

export const csrfToken = document.querySelector(
  "input[name=csrfmiddlewaretoken]",
).value;

$(".hamburger").on("click", () => {
  $(".hamburger").toggleClass("is-active");
  $(".sidebar").toggleClass("show-mobile");
});

$(".hide-sidebar").on("click", () => {
  const body = $("body");
  if (body.hasClass("sidebar-collapsed")) {
    body.removeClass("sidebar-collapsed");
    Cookies.set("sidebar-collapsed", "0");
  } else {
    body.addClass("sidebar-collapsed");
    Cookies.set("sidebar-collapsed", "1");
  }
});

$(".columnCollapseBtn").on("click", function () {
  $(this).closest(".block-small-column").toggleClass("collapsed");
});

// $(".nav-item a").on("click", (e) => {
//   const navItem = $(e.target).closest(".nav-item");
//   const collapseA = navItem.find('a[data-bs-toggle="collapse"]');
//   let collapseTargetName = collapseA.attr("data-bs-target");
//   let collapseTargetState = collapseA.hasClass("collapsed") === false;
//
//   if (collapseTargetName) {
//     collapseTargetName = collapseTargetName.replace("#", "");
//     let menuCollapseState = Cookies.get("sidebarMenuCollapseState");
//     if (menuCollapseState) {
//       menuCollapseState = JSON.parse(menuCollapseState);
//     } else {
//       menuCollapseState = {};
//     }
//     menuCollapseState[collapseTargetName] = collapseTargetState;
//     Cookies.set("sidebarMenuCollapseState", JSON.stringify(menuCollapseState));
//   }
// });

window.addEventListener("offline", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="offline">İnternet bağlantısı yoxdur</div>`,
  );
});

window.addEventListener("online", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="online">İnternet bağlantısı bərpa oldu</div>`,
  );
  setTimeout(() => {
    $("#connectivity").fadeOut(500, () => {
      $("#connectivity").remove();
    });
  }, 3000);
});

const subNavbar = $(".theme-sub-navbar");
if (subNavbar.length === 1) {
  $(document).on("scroll", () => {
    const scrollTop = $(window).scrollTop();
    const fixedStartHeight =
      $(".subheader")[0].offsetHeight - subNavbar[0].offsetHeight - 12;
    const contentDivHeight = subNavbar.next().height();
    if (scrollTop > fixedStartHeight && contentDivHeight > $(window).height()) {
      subNavbar.addClass("fixed");
      subNavbar.next().css("margin-top", subNavbar[0].offsetHeight);
    } else {
      subNavbar.removeClass("fixed");
      subNavbar.next().css("margin-top", 0);
    }
  });
}

$.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
  if (settings.jqXHR.status >= 500) {
    bsToast({
      title: "Xəta!",
      content: "Serverə sorğu zamanı xəta baş verdi",
    });
    console.error(settings, helpPage, message);
  } else if (settings.jqXHR.status === 464) {
    window.location.href = settings.jqXHR["responseJSON"]["redirect_url"];
  }
};

new ClipboardJS("button.clipboard").on("success", function (e) {
  bsToast({
    title: "Kopyalandı",
    content: "Mətn kopyalandı: " + e.text,
  });

  e.clearSelection();
});

// initialize jquery plugins
// use this function to initialize plugins after ajax calls (for example after modal content loaded)
initPlugins();
